import Vue from 'vue'
import AppPassword from './AppPassword.vue'
import VueRouter from 'vue-router'

import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './locales/public/i18n'
import VueGtag from "vue-gtag";
import store from './store'

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

const routes = [
    {
      path: '*',
      component: EnterPassword
    },
]

const router = new VueRouter(
    {
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })

import './assets/styles/main.scss'
import EnterPassword from './views/EnterPassword';

Vue.config.productionTip = false
Vue.use(VueGtag, {
  config: {
            id: "UA-92546995-1",
            params: {
                anonymize_ip: true
            }
           },
  bootstrap: false // GDPR compliant
}, router);

new Vue({
            router,
            store,
            i18n,
            render: h => h(AppPassword)
        }).$mount('#app')
